import Post from './Post';
import Pagination from './Pagination';

const PostList = ({ posts, handlePostSelect, togglePostText, expandedPosts, handlePostsPageChange, postsPage, hasMorePosts, totalPosts = 0, pageSize = 10 }) => {

return (posts.length > 0 ? (
    <>
      {posts.map((post) => (
        <Post
          key={`${post.group_id}-${post.date}`}
          post={post}
          onClick={handlePostSelect}
          togglePostText={togglePostText}
          expandedPosts={expandedPosts}
        />
      ))}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontWeight: 600, color: "#1976d2", fontSize: 16 }}>
              Дискуссии
            </span>
            <span style={{ fontWeight: 500, color: "#6b7280", fontSize: 14 }}>
              Показано {totalPosts > 0 ? ((postsPage - 1) * pageSize) + 1 : 0}-{Math.min(postsPage * pageSize, totalPosts)} из {totalPosts} записей
            </span>
          </div>
        </div>
        <Pagination
          currentPage={postsPage}
          totalPages={Math.ceil(totalPosts / pageSize) || 1}
          onPageChange={(newPage) => handlePostsPageChange(newPage)}
          maxVisiblePages={5}
        />
      </div>
    </>
  ) : (
    <p>Выберите группы и фильтры в верхней панели для отображения постов</p>
  ))
}

export default PostList;